// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3GInT","content":"GlobalSearch_content__2Dgw0"};